import { render, staticRenderFns } from "./BankRemitAnalitcsView.vue?vue&type=template&id=7ccac0a9&scoped=true&"
import script from "./BankRemitAnalitcsView.vue?vue&type=script&lang=ts&"
export * from "./BankRemitAnalitcsView.vue?vue&type=script&lang=ts&"
import style0 from "./BankRemitAnalitcsView.vue?vue&type=style&index=0&id=7ccac0a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccac0a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow,VSimpleTable})
